// Elenco ridotto di nomi italiani comuni per euristica quando i lavoratori
// hanno firstName e lastName invertiti nel DB. Usato per ordinare la tabella
// Visite mediche per cognome vero. Non serve una lista esaustiva — bastano
// i nomi frequenti nel set di dati.
const NAMES = new Set([
  'ALESSANDRO','ANDREA','ANTONIO','ANTONIETTA','ALESSANDRA','ANNA','ANGELO','ALDO','ALBERTO','ALFREDO',
  'BARBARA','BENEDETTA','BEATRICE','BRUNO',
  'CARLO','CARLA','CARMELA','CARMINE','CATERINA','CHIARA','CINZIA','CLAUDIA','CLAUDIO','CRISTINA','CRISTIAN','CRISTIANO',
  'DANIELE','DANIELA','DANILO','DAVIDE','DIEGO','DOMENICO','DONATO','DAVID','DARIO',
  'ELENA','ELISA','ELISABETTA','EMANUELE','EMANUELA','ENRICO','ENRICA','ERIKA','ERIK','ETTORE',
  'FABIO','FABRIZIO','FEDERICA','FEDERICO','FERDINANDO','FILIPPO','FRANCESCA','FRANCESCO','FRANCA','FRANCO',
  'GABRIELE','GABRIELLA','GAETANO','GEMMA','GIACOMO','GIAMPIERO','GIAMPAOLO','GIANFRANCO','GIANFRANCA','GIANLUCA','GIANNI','GIORGIA','GIORGIO','GIOVANNI','GIOVANNA','GIULIA','GIULIANO','GIULIO','GIUSEPPA','GIUSEPPE','GRAZIA','GRAZIELLA','GUIDO',
  'ILARIA','IRENE','IVAN','IVANO',
  'JACOPO','JESSICA',
  'LAURA','LEONARDO','LETIZIA','LIDIA','LINA','LOREDANA','LORENZO','LORENA','LUCA','LUCIA','LUCIANO','LUIGI','LUIGIA',
  'MADDALENA','MANUELA','MARCO','MARIA','MARIANNA','MARIO','MARINA','MARINELLA','MARTA','MARTINA','MASSIMILIANO','MASSIMO','MATTEO','MATTIA','MAURIZIO','MICHELE','MICHELA','MIRKO','MONICA',
  'NADIA','NATALE','NICOLA','NICOLETTA',
  'OLGA','ORNELLA','OSCAR',
  'PAOLA','PAOLO','PASQUALE','PATRIZIA','PIERA','PIETRO','PIERO','PIERANGELA','PIERANGELO',
  'QUINTINO',
  'RAFFAELE','RAFFAELLA','RENATA','RENATO','RICCARDO','RITA','ROBERTA','ROBERTO','ROMINA','ROSA','ROSANNA','ROSARIO','ROSSANA',
  'SABRINA','SALVATORE','SAMANTHA','SANDRA','SANDRO','SARA','SERENA','SERGIO','SILVIA','SILVANA','SILVIO','SIMONA','SIMONE','SONIA','STEFANIA','STEFANO','SUSANNA',
  'TERESA','TIZIANA','TOMMASO',
  'UGO','UMBERTO',
  'VALENTINA','VALERIA','VALERIO','VERONICA','VINCENZO','VITO','VITTORIA','VITTORIO',
  'WALTER',
  'ZAIRA',
]);

const norm = (s) => String(s || '').toUpperCase().trim().split(/\s+/)[0];

/** Ritorna true se ``s`` è (probabilmente) un nome italiano di persona. */
export const isItalianFirstName = (s) => NAMES.has(norm(s));

/**
 * Ritorna il cognome "vero" da usare per ordinare, con questa priorità:
 *  1. Se ``fiscalCode`` valido: usa le prime 3 lettere (codice fiscale
 *     italiano codifica il cognome nei primi 3 caratteri).
 *  2. Se ``firstName`` è un nome italiano comune → i campi sono invertiti,
 *     usa ``lastName`` (che in realtà contiene il cognome originale).
 *  3. Se ``lastName`` è un nome italiano comune → invertiti a rovescio,
 *     usa ``firstName`` come cognome.
 *  4. Fallback: ``lastName``.
 */
export const resolveSortKey = ({ firstName, lastName, fiscalCode }) => {
  const cf = String(fiscalCode || '').trim().toUpperCase();
  // Solo CF italiano valido (16 caratteri) usa i primi 3 chars.
  if (cf.length === 16 && /^[A-Z]{3}/.test(cf)) return cf.slice(0, 3);
  const first = String(firstName || '').trim().toUpperCase();
  const last = String(lastName || '').trim().toUpperCase();
  if (first && isItalianFirstName(first) && last) return last;
  if (last && isItalianFirstName(last) && first) return first;
  return last || first || '';
};
